import { ShellModel } from '../../shell/data-store';

export class VisitItemModel {
  id: number;
  name: string;
  description: string;
  ai_status: string;
  created_at: string;
  medical_service: {
    name: string;
  }
}

export class VisitListingModel extends ShellModel {
  data: Array<VisitItemModel> = [
    new VisitItemModel(),
    new VisitItemModel(),
    new VisitItemModel(),
    new VisitItemModel(),
    new VisitItemModel(),
    new VisitItemModel(),
    new VisitItemModel(),
    new VisitItemModel()
  ];

  constructor() {
    super();
  }
}
